


















import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {}
})
export default class PhotoHeader extends Vue {
  @Prop(String) private title: string;
  @Prop(String) private description: string;
  @Prop(String) private image: string;
  @Prop(String) private size: string;
  @Prop(String) private offset: string;

  constructor() {
    super();
  }
}
